import { z } from "zod";
const configSchema = z.object({
    apiUrl: z.string(),
});
export const config = configSchema.parse({
    apiUrl: process.env.API_URL || "http://localhost:3000/api/v1/admin",
});
